import {classes} from './AsideLoader.st.css';
import React from 'react';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../constants';
import {SkeletonSection} from '../../Skeleton/SkeletonSection/SkeletonSection';
import {SkeletonRow} from '../../Skeleton/SkeletonRow/SkeletonRow';
import {SkeletonLineWrapper} from '../../Skeleton/SkeletonLineWrapper/SkeletonLineWrapper';

export enum AsideLoaderDataHooks {
  Loader = 'AsideLoaderDataHooks.Loader',
  OldLoader = 'AsideLoaderDataHooks.OldLoader',
}

export const AsideLoader = () => {
  const {experiments} = useExperiments();
  if (experiments.enabled(SPECS.RefactorCheckoutSummaries)) {
    return (
      <SkeletonSection dataHook={AsideLoaderDataHooks.Loader}>
        <SkeletonRow>
          <SkeletonLineWrapper className={classes.skeleton} />
        </SkeletonRow>
      </SkeletonSection>
    );
  }
  return <div data-hook={AsideLoaderDataHooks.OldLoader} key={'aside-third'} className={classes.root}></div>;
};
